/* (ignored) */


//////////////////
// WEBPACK FOOTER
// readable-stream (ignored)
// module id = 4
// module chunks = main